import React, { useState, useEffect, useRef } from "react";
import { useLocation } from 'react-router-dom';
import './index.scss';
import './ipad.scss';
import './mobile.scss';
import { Cross as Hamburger } from 'hamburger-react';

import Logo from "../../img/header/logo";
import IconWhats from "../../img/header/whats";
import IconInsta from "../../img/header/insta";
import IconInstaMovil from "../../img/header/InstaMovil.svg";
import IconInstaMovilBlack from "../../img/header/InstaMovilBlack.svg";
import IconWhatsMovil from "../../img/header/WhatsWhiteMovil.svg";
import IconWhatsMovilBlack from "../../img/header/WhatsBlackMovil.svg";
import IconFace from "../../img/header/facebook";
import IconBe from "../../img/header/be";

import InstaOpenMovil from '../../img/header/InstaOpenMovil.svg';
import BeOpenMovil from '../../img/header/BeOpenMovil.svg';


const WHATSAPP_URL = 'https://api.whatsapp.com/send/?phone=12122030151&text&app_absent=0';
const INSTAGRAM_URL = 'https://www.instagram.com/tbestudio_/';
const BEHANCE_URL = 'https://www.behance.net/tbebranding';

const NAV_LINKS = [
    { href: "/servicios/#sectionTwo", label: "What we do" },
    { href: "/projects",              label: "Work"        },
    { href: "/contact",               label: "Contact"     },
];

function isNavActive(href, pathname) {
    if (href === '/servicios/#sectionTwo') return pathname === '/' || pathname === '/servicios';
    if (href === '/projects')             return pathname === '/projects' || pathname.startsWith('/detail');
    if (href === '/contact')              return pathname === '/contact';
    return false;
}

const OpenMenuSocialIcons = () => (
    <div>
        <div className="imagen">
            <a href={WHATSAPP_URL} target='_blank' rel="noreferrer">
                <img src={IconWhatsMovil} style={{ width: '180%', marginTop: '10%' }} alt="WhatsApp" />
            </a>
        </div>
        <div className="imagen">
            <a href={INSTAGRAM_URL} target='_blank' rel="noreferrer">
                <img src={InstaOpenMovil} width="80%" alt="Instagram" />
            </a>
        </div>
        <div className="imagen">
            <a href={BEHANCE_URL} target='_blank' rel="noreferrer">
                <img src={BeOpenMovil} alt="Behance" />
            </a>
        </div>
        <div className="imagenMovil">
            <a href={WHATSAPP_URL} target='_blank' rel="noreferrer">
                <img src={IconWhatsMovil} style={{ width: '180%', marginTop: '10%' }} alt="WhatsApp" />
            </a>
        </div>
        <div className="imagenMovil">
            <a href={INSTAGRAM_URL} target='_blank' rel="noreferrer">
                <img src={InstaOpenMovil} width="80%" alt="Instagram" />
            </a>
        </div>
        <div className="imagenMovil">
            <a href={BEHANCE_URL} target='_blank' rel="noreferrer">
                <img src={BeOpenMovil} alt="Behance" />
            </a>
        </div>
    </div>
);

const NavLinks = ({ pathname, onLinkClick }) => (
    <ul>
        {NAV_LINKS.map(({ href, label }) => (
            <li key={href}>
                <a
                    href={href}
                    className={`Links${isNavActive(href, pathname) ? ' Links--active' : ''}`}
                    onClick={onLinkClick}
                >
                    {label}
                </a>
            </li>
        ))}
    </ul>
);

const OpenMenuContent = ({ pathname, onLinkClick, socialIcons }) => (
    <div className="MenuTitleHeaders">
        <div className="elementOne"></div>
        <div className="elementTwo"></div>
        <div className="elementThree">
            <NavLinks pathname={pathname} onLinkClick={onLinkClick} />
            {socialIcons}
        </div>
    </div>
);


const HeaderContainer = (props) => {
    const { pathname } = useLocation();
    const [Menu, setMenu] = useState('0');
    const [isOpen, setOpen] = useState(false);
    const [titulos, setTitulos] = useState('hidden');
    const ubicacionPrincipal = useRef(window.pageYOffset);

    useEffect(() => {
        const handleScroll = () => {
            const desplazamientoActual = window.pageYOffset;
            const navbar = document.getElementById('navbar');
            if (navbar) {
                if (ubicacionPrincipal.current >= desplazamientoActual) {
                    navbar.style.top = '0';
                    setOpen(false);
                } else {
                    navbar.style.transition = '1s';
                    navbar.style.top = '-10vh';
                }
                if (window.scrollY < 800) {
                    navbar.style.top = '0';
                }
            }
            ubicacionPrincipal.current = desplazamientoActual;
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, []);

    function changeMenu(id) {
        if (id === '0') {
            setTitulos('visible');
            setMenu('1');
        }
        if (id === '1') {
            setMenu('0');
        }
    }

    return (
        <div>
            {/* ── NORMAL (dark) ── */}
            {props.name === 'normal' && (
                Menu === '0' ? (
                    <div className="HeaderNavContainer" id="navbar">
                        <div className="navigationMenu">
                            <div className="MenuBottoms">
                                <div className="containerTBE">
                                    <a href="/" className="LinkLogo">
                                        <Logo color="#FFF" className='Logo' />
                                    </a>
                                </div>
                                <div className="containerLinks">
                                    <div className="imagen">
                                        <a href={INSTAGRAM_URL} target='_blank' rel="noreferrer">
                                            <img src={IconInstaMovil} alt="Instagram" />
                                        </a>
                                    </div>
                                    <div className="imagen">
                                        <a href={WHATSAPP_URL} target='_blank' rel="noreferrer">
                                            <img src={IconWhatsMovil} alt="WhatsApp" />
                                        </a>
                                    </div>
                                    <div className="imagenMovil">
                                        <a href={INSTAGRAM_URL} target='_blank' rel="noreferrer">
                                            <img src={IconInstaMovil} alt="Instagram" />
                                        </a>
                                    </div>
                                    <div className="imagenMovil">
                                        <a href={WHATSAPP_URL} target='_blank' rel="noreferrer">
                                            <img src={IconWhatsMovil} alt="WhatsApp" />
                                        </a>
                                    </div>
                                </div>
                                <div className="containerBotton" onClick={() => changeMenu(Menu)}>
                                    <Hamburger toggled={isOpen} toggle={setOpen} />
                                </div>
                            </div>
                            <div className="MenuTitleHeaders" style={{ visibility: titulos }}>
                                <div className="elementOne"></div>
                                <div className="elementTwo"></div>
                                <div className="elementThree">
                                    <NavLinks pathname={pathname} />
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div className="HeaderNavContainerOpen" id="navbar">
                        <div className="navigationMenu">
                            <div className="MenuBottoms">
                                <div className="containerTBE">
                                    <a href="/" className="LinkLogo">
                                        <Logo color="#FFF" className='Logo' />
                                    </a>
                                </div>
                                <div className="containerLinks"></div>
                                <div className="containerBotton" onClick={() => changeMenu(Menu)}>
                                    <Hamburger toggled={isOpen} toggle={setOpen} />
                                </div>
                            </div>
                            <OpenMenuContent
                                pathname={pathname}
                                onLinkClick={() => changeMenu(Menu)}
                                socialIcons={<OpenMenuSocialIcons />}
                            />
                        </div>
                        <div className="filtro"></div>
                    </div>
                )
            )}

            {/* ── NORMAL WHITE ── */}
            {props.name === 'normalWhite' && (
                Menu === '0' ? (
                    <div className="HeaderNavContainer" id="navbar">
                        <div className="navigationMenu">
                            <div className="MenuBottoms">
                                <div className="containerTBE" style={{ backgroundColor: "#FFF" }}>
                                    <a href="/" className="LinkLogo">
                                        <Logo color="#000" className='Logo' />
                                    </a>
                                </div>
                                <div className="containerLinks" style={{ backgroundColor: "#FFF" }}>
                                    <div className="imagen">
                                        <a href={INSTAGRAM_URL} target='_blank' rel="noreferrer">
                                            <img src={IconInstaMovilBlack} alt="Instagram" />
                                        </a>
                                    </div>
                                    <div className="imagen">
                                        <a href={WHATSAPP_URL} target='_blank' rel="noreferrer">
                                            <img src={IconWhatsMovilBlack} alt="WhatsApp" />
                                        </a>
                                    </div>
                                    <div className="imagenMovil">
                                        <a href={INSTAGRAM_URL} target='_blank' rel="noreferrer">
                                            <img src={IconInstaMovilBlack} alt="Instagram" />
                                        </a>
                                    </div>
                                    <div className="imagenMovil">
                                        <a href={WHATSAPP_URL} target='_blank' rel="noreferrer">
                                            <img src={IconWhatsMovilBlack} alt="WhatsApp" />
                                        </a>
                                    </div>
                                </div>
                                <div className="containerBotton" onClick={() => changeMenu(Menu)} style={{ backgroundColor: "#FFF" }}>
                                    <Hamburger toggled={isOpen} color="#000" toggle={setOpen} />
                                </div>
                            </div>
                            <div className="MenuTitleHeaders" />
                        </div>
                    </div>
                ) : (
                    <div className="HeaderNavContainerOpen" id="navbar">
                        <div className="navigationMenu">
                            <div className="MenuBottoms">
                                <div className="containerTBE">
                                    <a href="/" className="LinkLogo">
                                        <Logo color="#FFF" className='Logo' />
                                    </a>
                                </div>
                                <div className="containerLinks"></div>
                                <div className="containerBotton" onClick={() => changeMenu(Menu)}>
                                    <Hamburger toggled={isOpen} toggle={setOpen} />
                                </div>
                            </div>
                            <OpenMenuContent
                                pathname={pathname}
                                socialIcons={<OpenMenuSocialIcons />}
                            />
                        </div>
                        <div className="filtro"></div>
                    </div>
                )
            )}

            {/* ── SECOND HEADER ── */}
            {props.name === 'SecondHeader' && (
                Menu === '0' ? (
                    <div className="HeaderNavContainer" id="navbar">
                        <div className="navigationMenu">
                            <div className="MenuBottoms">
                                <div className="containerTBE">
                                    <a href="/" className="LinkLogo">
                                        <Logo color="#FFF" className='Logo' />
                                    </a>
                                </div>
                                <div className="containerLinks">
                                    <div className="imagen">
                                        <a href={INSTAGRAM_URL} target='_blank' rel="noreferrer">
                                            <IconInsta color="#FFF" ancho='33.6' alto='33.6' />
                                        </a>
                                    </div>
                                    <div className="imagen">
                                        <a href={WHATSAPP_URL} target='_blank' rel="noreferrer">
                                            <IconWhats color="#FFF" className='imgen' />
                                        </a>
                                    </div>
                                </div>
                                <div className="containerBotton" onClick={() => changeMenu(Menu)}>
                                    <Hamburger toggled={isOpen} toggle={setOpen} />
                                </div>
                            </div>
                            <div className="MenuTitleHeaders" />
                        </div>
                    </div>
                ) : (
                    <div className="HeaderNavContainerOpen" id="navbar">
                        <div className="navigationMenu">
                            <div className="MenuBottoms">
                                <div className="containerTBE">
                                    <a href="/" className="LinkLogo">
                                        <Logo color="#FFF" className='Logo' />
                                    </a>
                                </div>
                                <div className="containerLinks"></div>
                                <div className="containerBotton" onClick={() => changeMenu(Menu)}>
                                    <Hamburger toggled={isOpen} toggle={setOpen} />
                                </div>
                            </div>
                            <OpenMenuContent
                                pathname={pathname}
                                socialIcons={
                                    <div>
                                        <div className="imagen">
                                            <a href={WHATSAPP_URL} target='_blank' rel="noreferrer">
                                                <IconWhats color="#FFF" />
                                            </a>
                                        </div>
                                        <div className="imagen">
                                            <a href={INSTAGRAM_URL} target='_blank' rel="noreferrer">
                                                <IconInsta color="#FFF" ancho='33.6' alto='33.6' />
                                            </a>
                                        </div>
                                        <div className="imagen">
                                            <a href={BEHANCE_URL} target='_blank' rel="noreferrer">
                                                <IconBe back='#FFF' fill='#FF4700' />
                                            </a>
                                        </div>
                                    </div>
                                }
                            />
                        </div>
                        <div className="filtro"></div>
                    </div>
                )
            )}

            {/* ── WHITE ── */}
            {props.name === 'white' && (
                Menu === '0' ? (
                    <div className="HeaderNavContainerWhite" id="navbar">
                        <div className="navigationMenu">
                            <div className="MenuBottoms">
                                <div className="containerTBE">
                                    <a href="/" className="LinkLogo">
                                        <Logo color="#000" className='Logo' />
                                    </a>
                                </div>
                                <div className="containerLinks">
                                    <div className="imagen">
                                        <a href={INSTAGRAM_URL} target='_blank' rel="noreferrer">
                                            <IconInsta color="#000" relleno='#FFF' ancho='33.6' alto='33.6' />
                                        </a>
                                    </div>
                                    <div className="imagen">
                                        <IconWhats color="#000" />
                                    </div>
                                </div>
                                <div className="containerBotton" onClick={() => changeMenu(Menu)}>
                                    <Hamburger color="#000" />
                                </div>
                            </div>
                            <div className="MenuTitleHeaders" />
                        </div>
                    </div>
                ) : (
                    <div className="HeaderNavContainerOpenWhite" id="navbar">
                        <div className="navigationMenu">
                            <div className="MenuBottoms">
                                <div className="containerTBE">
                                    <a href="/" className="LinkLogo">
                                        <Logo color="#FFF" className='Logo' />
                                    </a>
                                </div>
                                <div className="containerLinks"></div>
                                <div className="containerBotton" onClick={() => changeMenu(Menu)}>
                                    <Hamburger />
                                </div>
                            </div>
                            <OpenMenuContent
                                pathname={pathname}
                                socialIcons={
                                    <div>
                                        <div className="imagen">
                                            <a href={INSTAGRAM_URL} target='_blank' rel="noreferrer">
                                                <IconInsta color="#000" relleno='#FFF' ancho='38.6' alto='38.6' />
                                            </a>
                                        </div>
                                        <div className="imagen">
                                            <IconFace />
                                        </div>
                                        <div className="imagen">
                                            <IconBe />
                                        </div>
                                    </div>
                                }
                            />
                        </div>
                    </div>
                )
            )}

            {/* ── BLACK ── */}
            {props.name === 'black' && (
                Menu === '0' ? (
                    <div className="HeaderNavContainerBlack" id="navbar">
                        <div className="navigationMenu">
                            <div className="MenuBottoms">
                                <div className="containerTBE">
                                    <a href="/" className="LinkLogo">
                                        <Logo color="#FFF" />
                                    </a>
                                </div>
                                <div className="containerLinks">
                                    <div className="imagen">
                                        <a href={INSTAGRAM_URL} target='_blank' rel="noreferrer">
                                            <IconInsta color="#FFF" relleno='#000' ancho='33.6' alto='33.6' />
                                        </a>
                                    </div>
                                    <div className="imagen">
                                        <IconWhats color="#FFF" />
                                    </div>
                                </div>
                                <div className="containerBotton" onClick={() => changeMenu(Menu)}>
                                    <Hamburger />
                                </div>
                            </div>
                            <div className="MenuTitleHeaders" />
                        </div>
                    </div>
                ) : (
                    <div className="HeaderNavContainerOpenBlack" id="navbar">
                        <div className="navigationMenu">
                            <div className="MenuBottoms">
                                <div className="containerTBE">
                                    <a href="/" className="LinkLogo">
                                        <Logo color="#FFF" />
                                    </a>
                                </div>
                                <div className="containerLinks"></div>
                                <div className="containerBotton" onClick={() => changeMenu(Menu)}>
                                    <Hamburger />
                                </div>
                            </div>
                            <OpenMenuContent
                                pathname={pathname}
                                socialIcons={
                                    <div>
                                        <div className="imagen">
                                            <a href={INSTAGRAM_URL} target='_blank' rel="noreferrer">
                                                <IconInsta color="#FFF" relleno='#000' ancho='38.6' alto='38.6' />
                                            </a>
                                        </div>
                                        <div className="imagen">
                                            <IconFace />
                                        </div>
                                        <div className="imagen">
                                            <IconBe />
                                        </div>
                                    </div>
                                }
                            />
                        </div>
                    </div>
                )
            )}
        </div>
    );
};

export default HeaderContainer;
